// ======================================================================
// File Name       : EmailEditUser
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Button, Table, Row, Form } from 'react-bootstrap';

class EmailEditUser extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.authority === this.props.authority &&
    nextProps.editingUser === this.props.editingUser;
    return !shouldNotUpdate;
  }

  render() {
    const {
       editingUser,
    } = this.props;
    const editingUserList = Object.keys(editingUser).sort((a, b) => {
      if (editingUser[a].addNew && !editingUser[b].addNew) {
        return -1;
      } else if (!editingUser[a].addNew && editingUser[b].addNew) {
        return 1;
      }
      if (editingUser[a].index < editingUser[b].index) {
        return -1;
      } else if (editingUser[a].index > editingUser[b].index) {
        return 1;
      }
      return 0;
    });
    return (
      <div>
        <Form.Group className={'form-info margin-top-50'} id="scroll-table-email">
          <Row>
            <Col sm={12}>
              <Col sm={6} as={Form.Label} className="margin-top-15 padding-left-right-clear">
                {`選択中のユーザー：${editingUserList.length} ユーザー`}
              </Col>
              <Col className="text-right padding-left-right-clear">
                <Button variant='default' onClick={this.props.handleRemoveAllUser}>ユーザー一括削除</Button>
              </Col>
            </Col>
          </Row>
          <Col>
            <Table striped hover className="margin-top-7 margin-bottom-0">
              <thead>
                <tr>
                  <th>ユーザー名</th>
                  <th>ログインID</th>
                  <th>グループ名</th>
                  <th>メールアドレス</th>
                  <th className="col-md-1">操作</th>
                </tr>
              </thead>
              <tbody>
                {editingUserList.map((userSecernId, index) => {
                  const userInfo = editingUser[userSecernId];
                  if (!userInfo) return null;
                  return (
                    <tr
                      key={index}
                      className={userInfo.addNew ? 'background_new_record' : ''}
                    >
                      <td>
                        {userInfo.userName}
                      </td>
                      <td>
                        {userInfo.loginId}
                      </td>
                      <td>
                        {userInfo.groupName}
                      </td>
                      <td>
                        {userInfo.mailAddress}
                      </td>
                      <td className="text-center">
                        <i
                          role="button"
                          className="bi bi-trash"
                          onClick={this.props.handleRemoveUser.bind(null, userSecernId)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default EmailEditUser;
